module.exports = __webpack_public_path__ + "Simple-Line-Icons.00ce23caac2c875bcc6d.svg";


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/assets/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.svg?-i3a2kk
// module id = ../../../../../src/assets/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.svg?-i3a2kk
// module chunks = styles